import React, { useRef, useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import { Grid, Paper } from "@material-ui/core";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import device from "current-device";
import GroupsIcon from '@mui/icons-material/Groups';
import { DataGrid } from "@material-ui/data-grid";
import RuleIcon from '@mui/icons-material/Rule';
import { IconButton } from "@mui/material";
import PlayCircleIcon from '@mui/icons-material/PlayCircle';

import { SignDialog } from "../../components/dialog/SignDialog";
import { useDataProvider } from "../../api/DataProvider";
import { useTranslation } from "react-i18next";

import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import { SearchInput } from "../search/SearchInput";
import Checkbox from '@mui/material/Checkbox';

import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import CloseIcon from '@mui/icons-material/Close';
import LockIcon from '@mui/icons-material/Lock';
import NoEncryptionGmailerrorredIcon from '@mui/icons-material/NoEncryptionGmailerrorred';

import ConfirmationDialog from '../utils/ConfirmationDialog';

import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import SignLanguageIcon from "@mui/icons-material/SignLanguage";
import Tooltip from '@material-ui/core/Tooltip';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';



const DEFAULT_DATA = {
  'name': '',
  'information': '',
  'activateDeadline': false,
}


export function FormCreateTaskDialog(props) {
  const { openDialog, setOpenDialog, prevTaskFormData, setPrevTaskFormData, handleSendFormCreateTask, handleUpdateFormTask, sendHideTask, sendDeleteTask, infoTeam } = props;
  const { t } = useTranslation("global")
  
  
  const [formCompleted, setFormCompleted] = useState(false)
  const [ rows, setRows ] = useState([]);
  const [ rowsSelected, setRowsSelected ] = useState([]);
  const [ searchedRows, setSearchedRows ] = useState([])
  const rowsSelectedRef = useRef([]);

  const [ pageSize, setPageSize ] = useState(5);
  const [ dialogElements, setDialogElements ] = useState([]);
  const { currentUser, token_id, genEntryByLemma, genEntryByGloss, getLemmaByGloss, getListAllLemmasAvailable, getLemmaMeaningByGloss, json_data_lemma, json_data_meaning, json_data_glosses, getListAllGlossesAvailable } = useDataProvider();

  const [ openDialogSign, setOpenDialogSign ] = useState(false);
  const [ dataDialogUsedTask, setDataDialogUsedTask ] = useState(null);
  const [ prevDialogPosition, setPrevDialogPosition ] = useState(undefined);

  const [ showSelectionTable, setShowSelectionTable ] = useState(true)
  const [ showSelectedElements, setShowSelectedElements ] = useState(false);

  const [openTooltip, setOpenTooltip] = useState(false);

  // const task_id_ref = useRef("");
  // const information_ref = useRef("");
  // const arr_elements_ref = useRef("");
  // const [activateDeadline, setActivateDeadline] = useState(false)
  // const [deadline, setDeadline] = useState(new Date());
  // const [deadlineTimestamp, setDeadlineTimestamp] = useState(new Date().getTime());

  const [formTask_dialog_data, setFormTask_dialog_data] = useState(DEFAULT_DATA);
  const [deadline, setDeadline] = useState("");
  const [deadlineTimestamp, setDeadlineTimestamp] = useState("");
  const [arr_elements_selected, setArr_elements_selected] = useState([]);

  const [ isComfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
  


  const [sortModel, setSortModel] = useState([
    // { field: "participation", sort: "desc" },
    { field: "lemma", sort: "asc" }
  ]);

  const [columns, setColumns] = useState([
    { field: "model", headerName: "", filterable: false, sortable: false, flex: 0.1, renderCell: (params) => AddIcon(params) },
    { field: "used", headerName: "R", filterable: false, sortable: false, flex: 0.1, renderCell: (params) => handleCountUsed(params) },
    { field: "lemma", headerName: t("sTable.name"), sortable: false, flex: 0.35, renderCell: (params) => ( <span style={{ fontSize: '13px' }}>{params.row.lemma}</span>) },
    { field: "gloss", headerName: t("sTable.ID"), sortable: false, flex: 0.30, renderCell: (params) => ( <span style={{ fontSize: '10px' }}>{params.row.gloss}</span>) },
    { field: "participation", headerName: t("sTeams.table_field_action"), headerAlign: "center", sortable: false, flex: 0.25 , align: "center", renderCell: (params) => gridTaskStatus(params)},
  ]);

  function AddIcon2(params) {
    return (
        <p style={{ display: 'flex', alignItems: 'center' }}>
            <SignLanguageIcon fontSize='small' style={{ color: params.row.model ? 'green' : 'red', marginRight: '5px' }} />
            <IconButton style={{padding: 0, fontSize: '0.8em', color: params.row.used > 0 ? 'green' : 'inherit'}} onClick={() => handleCountUsed(params)}>
              <span>
                {" ("}{params.row.used}{")"}
              </span>
            </IconButton>
        </p>
    );
  }

  function AddIcon(params) {
    return (
                <SignLanguageIcon 
                    fontSize='small' 
                    style={{ 
                        color: params.row.model ? 'green' : 'red'
                    }} 
                />
    );
  }

  function handleCountUsed(params) {
    return (
        <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Button 
                style={{ backgroundColor: params.row.used.length > 0 ? '#f13232' : 'inherit', padding: '5px', fontSize: '0.8em' }} 
                onClick={() => setDataDialogUsedTask(params.row.used)}
            >
                <strong style={{ color: params.row.used.length > 0 ? 'white' : 'inherit' }}>
                    {params.row.used.length}
                </strong>
            </Button>
        </div>
    );
  }




  // useEffect(() => {
  //   console.log("🚀 ~ file: FormCreateTaskDialog.js:56 ~ FormCreateTaskDialog ~ infoTeam:", infoTeam)
  // }, [infoTeam]);


  useEffect(() => {
    // console.log("🚀 ~ file: FormCreateTaskDialog.js:56 ~ FormCreateTaskDialog ~ prevTaskFormData:", prevTaskFormData)
    // console.log("🚀 ~ file: FormCreateTaskDialog.js:56 ~ FormCreateTaskDialog ~ default formTask_dialog_data:", formTask_dialog_data)

    if (prevTaskFormData !== null){
      setFormTask_dialog_data({'name': prevTaskFormData.task_id, 'information': prevTaskFormData.information, 'activateDeadline': prevTaskFormData.deadline_timestamp !== ""});
      setArr_elements_selected(prevTaskFormData.arr_elements)
      setDeadlineTimestamp(prevTaskFormData.deadline_timestamp)
      setDeadline(new Date(prevTaskFormData.deadline_timestamp))
      handleUpdateRowsSelected(prevTaskFormData.arr_elements)
      setShowSelectionTable(false)
      setShowSelectedElements(true)
    }
  }, [prevTaskFormData]);


  function handleRowClick(params) {
    // console.log(getLemmaMeaningByGloss(params.row.id))
    const { lemma, meaning } = getLemmaMeaningByGloss(params.row.id);
    const dialog_elements_obtained = genEntryByLemma([lemma]);
    setDialogElements(dialog_elements_obtained);
    setPrevDialogPosition({
        "lemma": lemma,
        "meaning": meaning,
        "gloss": params.row.id
    })
    setOpenDialogSign(true)
  }

  function gridTaskStatus(params) {
    return <div>
        <Checkbox checked={params.row.participation} onClick={(event) => handleChangeParticipation(event, params.row)} />
        <IconButton onClick={() => handleRowClick(params)}> <PlayCircleIcon color="primary"/> </IconButton>
      </div>
  }

  const handleChangeParticipation = (event, row) => {
    // console.log("🚀 ~ file: FormCreateTaskDialog.js:100 ~ handleChangeParticipation ~ handleChangeParticipation:", row)
    setArr_elements_selected((prevList) => {
      const index = prevList.indexOf(row.id);
      if (index === -1) {
        return [...prevList, row.id];
      } else {
        return prevList.filter((item) => item !== row.id);
      }
    });
  }

  const handleUpdateRowsSelected = (arr_elements_selected) => {
    
    // console.log("🚀 ~ file: FormCreateTaskDialog.js:158 ~ handleUpdateRowsSelected ~ handleUpdateRowsSelected:", arr_elements_selected)

    rowsSelectedRef.current = arr_elements_selected.map(selectedId => {
      const row = rows.find(row => row.id === selectedId);
      return row ? { ...row, participation: true } : null;
    }).filter(row => row !== null);

    // console.log("🚀 ~ file: FormCreateTaskDialog.js:158 ~ handleUpdateRowsSelected ~ rowsSelectedRef.current:", rowsSelectedRef.current)

    setRowsSelected(rowsSelectedRef.current);
  };

  useEffect(() => {
    handleUpdateRowsSelected(arr_elements_selected)
  }, [arr_elements_selected]);
  


  // useEffect(() => {
  //   // Actualizar el estado cuando el ref cambia
  //   console.log("🚀 ~ file: FormCreateTaskDialog.js:126 ~ FormCreateTaskDialog ~ rowsSelectedRef: VER2", rowsSelectedRef)
  //   setRowsSelected(rowsSelectedRef.current);
  // }, [rowsSelectedRef]);
  

  // useEffect(() => {
  //   console.log("🚀 ~ file: FormCreateTaskDialog.js:118 ~ FormCreateTaskDialog ~ rowsSelected: ", rowsSelected)
  // }, [rowsSelected]);


  // useEffect(() => {
  //   console.log("🚀 ~ file: FormCreateTaskDialog.js:118 ~ FormCreateTaskDialog ~ rows: ", rows)
  // }, [rows]);
  

  


  useEffect(() => {
    let arr_data = [];
    const arr_lemmas = getListAllLemmasAvailable()
    // console.log("🚀 ~ file: FormCreateTaskDialog.js:150 ~ useEffect ~ arr_lemmas:", arr_lemmas)

    arr_lemmas.forEach((element_lemma, indexLemma) => {
      const lemma_label = json_data_lemma[element_lemma]['label'];
      const arr_meanings = json_data_lemma[element_lemma]['arr_meanings'];
    
      arr_meanings.forEach((element_meaning, indexMeaning) => {
        const arr_glosses = json_data_meaning[element_meaning]['arr_glosses'];
    
        arr_glosses.forEach((element_gloss, indexGloss) => {
          arr_data.push({
            id: element_gloss,
            lemma: lemma_label,
            model: json_data_glosses[element_gloss]['model'],
            gloss: json_data_glosses[element_gloss]['label'],
            // used: Math.random() < 0.6 ? 0 : Math.random() < 0.5 ? 1 : 2,
            used: infoTeam['arr_elements'] && infoTeam['arr_elements'][element_gloss]  ? infoTeam['arr_elements'][element_gloss] : [],
            participation: false
          });
        });
      });
    });


    setRows(arr_data)
    setSearchedRows(arr_data)

    if (prevTaskFormData === null){
      setArr_elements_selected([])
      setShowSelectedElements(false)
      setShowSelectionTable(true)
      rowsSelectedRef.current = []
      setRowsSelected([])
    }

  }, [openDialog]);


  useEffect(() => {
    const updated_arr_data = rows.map(element => {
      if (arr_elements_selected.includes(element.id)) {
        return { ...element, participation: true };
      } else {
        return { ...element, participation: false };
      }
    })
    setRows(updated_arr_data)


    const updated_arr_data_search = searchedRows.map(element => {
      if (arr_elements_selected.includes(element.id)) {
        return { ...element, participation: true };
      } else {
        return { ...element, participation: false };
      }
    })
    setSearchedRows(updated_arr_data_search)

    // handleFormCompletion()
  }, [arr_elements_selected]);


  const handleClose = () => {
    setOpenDialog(false);
    setPrevTaskFormData(null)
    setFormTask_dialog_data(DEFAULT_DATA)
    setDeadline("")
    setDeadlineTimestamp("")
  };

  function sendForm(){
    const formCreateTeam = {
      team_id: infoTeam['_id'],
      task_id: formTask_dialog_data['name'],
      information: formTask_dialog_data['information'],
      arr_elements: arr_elements_selected.join(','),
      deadline_timestamp: deadlineTimestamp
    };
    // console.log("🚀 ~ file: FormCreateTaskDialog.js:121 ~ sendForm ~ formCreateTeam:", formCreateTeam)
    handleSendFormCreateTask(formCreateTeam);
    handleClose();
  };


  function updateForm(){
    // console.log("🚀 ~ file: FormCreateTaskDialog.js:259 ~ updateForm ~ updateForm:", updateForm)
    const updated_data = {
      information: formTask_dialog_data['information'],
      arr_elements: arr_elements_selected.join(','),
      deadline_timestamp: deadlineTimestamp
    };

    handleUpdateFormTask(prevTaskFormData._id, updated_data);
    handleClose();
  };
  

  const handleChange = (selectedValue, fieldName) => {
    switch (fieldName) {
      case 'name':
        selectedValue = selectedValue.replace(/[^a-zA-Z0-9_-]/g, '');
        selectedValue = selectedValue.toUpperCase()
        break;
      case 'information':
        break;
      case 'activateDeadline':
        if (selectedValue){
          const date_init = new Date();
          date_init.setDate(date_init.getDate() + 1);
          setDeadline(date_init)
          setDeadlineTimestamp(date_init.getTime())
        }else{
          setDeadline("")
          setDeadlineTimestamp("")
        }
        
        break;
    }

    setFormTask_dialog_data(prevState => ({
      ...prevState,
      [fieldName]: selectedValue,
    }));
  };



  useEffect(() => {
    // console.log("🚀 ~ file: FormCreateTaskDialog.js:283 ~ FormCreateTaskDialog ~ formTask_dialog_data:", formTask_dialog_data)
    // console.log("🚀 ~ file: FormCreateTaskDialog.js:283 ~ FormCreateTaskDialog ~ deadline:", deadline)
    // console.log("🚀 ~ file: FormCreateTaskDialog.js:283 ~ FormCreateTaskDialog ~ deadlineTimestamp:", deadlineTimestamp)
    // console.log("🚀 ~ file: FormCreateTaskDialog.js:283 ~ FormCreateTaskDialog ~ arr_elements_selected:", arr_elements_selected)

    // console.log("🚀 ~ file: FormCreateTaskDialog.js:283 ~ FormCreateTaskDialog ~ prevTaskFormData:", prevTaskFormData)
    

    if (formTask_dialog_data.name !== "" && formTask_dialog_data.information !== "" && arr_elements_selected.length > 0) {
      setFormCompleted(true)
    } else {
      setFormCompleted(false)
    }

  }, [formTask_dialog_data, deadline, deadlineTimestamp, arr_elements_selected]);
  


  // const handleFormCompletion = () => {
  //   if (formTask_dialog_data.name !== "" && formTask_dialog_data.information !== "" && arr_elements_selected.length > 0) {
  //     setFormCompleted(true)
  //   } else {
  //     setFormCompleted(false)
  //   }
  // };


  const handleFocus = (event) => {
    if (device.type !== 'desktop') {
        const el = event.target.closest('.sig_BugReport_New_InputContainer');
        el.scrollIntoView({behavior: "smooth"});
    }
  }

  function handlePageSizeChange(params) {
    setPageSize(params.pageSize);
  }

  
  // setRowsSelected

  function strTextFieldArrElements(){
    const size = arr_elements_selected.length;
    if (size == 0) {
      return "Sin selección"
    }
    if (size == 1) {
      return "Seleccionado 1 elemento"
    }
    if (size > 1) {
      return "Seleccionados "+ size +" elementos"
    }
  }


  function handleSearch(e) {
    const search = e.target.value
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase();
    var sr = [];

    if (search.length < 4){
      rows.forEach((i) => {
        try {
          if (
            i["lemma"]
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
              .toLowerCase()
              .startsWith(search)
              // .includes(search)
          ) {
            sr.push(i);
          } 
        } catch {}
      });
    }else {
      rows.forEach((i) => {
        try {
          if (
            i["lemma"]
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
              .toLowerCase()
              // .startsWith(search)
              .includes(search)
          ) {
            sr.push(i);
          } 
        } catch {}
      });
    }
    
    setSearchedRows(sr);
  }


  function handleBlockTask(){
    const date_init = new Date();
    setDeadline(date_init)
    setDeadlineTimestamp(date_init.getTime())
    setFormTask_dialog_data(prevState => ({...prevState, 'activateDeadline': true}));
    const updated_data = {
      deadline_timestamp: date_init.getTime()
    };
    handleUpdateFormTask(prevTaskFormData._id, updated_data)
    handleClose()
  }
  


  return (
    <>
    <Dialog className="sig_Drawer_SettingsModal_Root sig_FormCreateTask_New_Root" open={openDialog} onClose={handleClose}>
      <DialogTitle className="sig_Drawer_SettingsModal_Title sig_Main_TitleWithIcon">
        Crear tarea <GroupsIcon /> 
      </DialogTitle>

      <DialogContent className="sig_Drawer_SettingsModal_Content sig_BugReport_New_Content" style={{margin:'auto'}}>
        <div className="sig_BugReport_New_Info">
          { prevTaskFormData !== null && 
            <div style={{ padding: '0 10px', width: '50%', display: 'flex', justifyContent: 'space-between', margin: 'auto', border: '3px solid #0867b2', borderRadius: '10px', backgroundColor: '#a2d2f9' }}>

              <IconButton onClick={() => { sendHideTask(prevTaskFormData._id, prevTaskFormData.visibility); setPrevTaskFormData(prevState => ({ ...prevState, 'visibility': !prevState.visibility}))}}>{prevTaskFormData.visibility ? <VisibilityIcon color='success' fontSize='small'/> : <VisibilityOffIcon color='error' fontSize='small'/>}</IconButton>

              <IconButton onClick={ handleBlockTask }><LockIcon fontSize='small'/></IconButton>

              <IconButton onClick={() => {setIsConfirmDialogOpen(true)}}><CloseIcon color='error' fontSize='small'/></IconButton>

            </div>
          }

          <ConfirmationDialog 
            open={isComfirmDialogOpen} 
            onClose={() => setIsConfirmDialogOpen(false)} 
            onConfirm={() => { sendDeleteTask(prevTaskFormData._id); setIsConfirmDialogOpen(false); handleClose()}} 
            message={t("sConfirmationDialog.question_exec_action")}
          />


          <div className="sig_BugReport_New_InputContainer">
            <p className="sig_BugReport_New_Title_no_asterisk">Nombre de la tarea</p>
            <TextField              
              onChange={(e) => handleChange(e.target.value, 'name')}
              margin="dense" 
              id="bugTitle" 
              fullWidth 
              // inputRef={task_id_ref} 
              value={formTask_dialog_data.name}

              disabled={prevTaskFormData!==null}

              />
          </div>

          <div className="sig_BugReport_New_InputContainer">
            <p className="sig_BugReport_New_Title_no_asterisk">Información de la tarea</p>
            <TextField 
              onChange={(e) => handleChange(e.target.value, 'information')}
              className='sig_BugReport_New_TextField' 
              margin="dense" id="bugBody" 
              fullWidth 
              value={formTask_dialog_data.information}
              // inputRef={formTask_dialog_data.information} 
              multiline rows={1} />
          </div>

          <div className="sig_BugReport_New_InputContainer">
            <p className="sig_BugReport_New_Title_no_asterisk">Fecha límite</p>
            <div style={{ display: 'flex' }}>


            

              <Checkbox style={{ marginRight: '5px' }} onChange={(e) => handleChange(e.target.checked, 'activateDeadline')} checked={formTask_dialog_data.activateDeadline} />

              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DateTimePicker
                  disabled={!formTask_dialog_data.activateDeadline}
                  renderInput={(props) => <TextField {...props} />}
                  value={deadline}
                  format="yyyy/MM/dd HH:mm"
                  onChange={(newValue) => {
                    setDeadline(newValue);
                    setDeadlineTimestamp(newValue.getTime())
                  }}
                />
              </LocalizationProvider>
              <TextField
                value={deadlineTimestamp}
                disabled
                style={{ marginLeft: '20px' }}
                // Additional styling or props can be added as needed
              />
            </div>
          </div>




          <div className="sig_BugReport_New_InputContainer">
            {/* <p className="sig_BugReport_New_Title_no_asterisk">Elementos  <IconButton onClick={()=> setShowSelectionTable(!showSelectionTable)}><RuleIcon color='primary'/></IconButton></p> */}
            <p className="sig_BugReport_New_Title_no_asterisk">Elementos </p>

            <Accordion className='sig_SignModal_MoreInfoContainer' expanded={showSelectedElements} onChange={() => {setShowSelectedElements(!showSelectedElements); setShowSelectionTable(!showSelectionTable)}}>
              <AccordionSummary className='sig_SignModal_MoreInfoButton' style={{ backgroundColor: rowsSelected.length > 0 ? 'red' : '' }} expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header"> {strTextFieldArrElements()} </AccordionSummary>
              <AccordionDetails style={{border: '1px solid black'}}>
                <DataGrid
                  autoHeight
                  pageSize={pageSize}
                  onPageSizeChange={handlePageSizeChange}
                  rowsPerPageOptions={[10, 25, 50, 100]}
                  disableSelectionOnClick
                  pagination
                  columns={columns}
                  rows={rowsSelected}
                  // hideFooter={true}
                  sortModel={sortModel}
                  disableColumnFilter
              />

              </AccordionDetails>
            </Accordion>

          </div>

          
          

          {showSelectionTable ? (
              <div>
                <div className="sig_Drawer_SettingsModal_Title">LISTADO DE TÉRMINOS</div>
                <br></br>
                <SearchInput handleSearch={handleSearch} /> 
                <DataGrid
                  autoHeight
                  pageSize={pageSize}
                  onPageSizeChange={handlePageSizeChange}
                  rowsPerPageOptions={[10, 25, 50, 100]}
                  disableSelectionOnClick
                  pagination
                  columns={columns}
                  rows={searchedRows}
                  sortModel={sortModel}
                />
              </div>
            ) : (
              <></> // Otra representación cuando showSelectionTable es falso
            )}
        </div>
      </DialogContent>
      <DialogActions>
        <div>

          {prevTaskFormData === null ?

            <Button className="sig_FormDialog_Button sig_FormDialog_Button_Send" onClick={sendForm} disabled={!formCompleted}>
              {t("strButton.btn_send").toUpperCase()}
            </Button>
          :
            <Button className="sig_FormDialog_Button sig_FormDialog_Button_Send" onClick={updateForm} disabled={!formCompleted}>
              ACTUALIZAR
            </Button>
          }
          
          <Button className="sig_FormDialog_Button sig_FormDialog_Button_Cancel" onClick={handleClose}>
            {t("strButton.btn_cancel").toUpperCase()}
          </Button>
        </div>
      </DialogActions>
    </Dialog>
    <SignDialog dialogElements={dialogElements} setDialogElements={setDialogElements} loading={false} openDialog={openDialogSign} setOpenDialog={setOpenDialogSign} prevDialogPosition={prevDialogPosition} setPrevDialogPosition={setPrevDialogPosition} teamTask={{isAdmin: true}}/>


    {/* <Dialog open={dataDialogUsedTask.length > 0} onClose={()=>setDataDialogUsedTask([])}> */}
    {dataDialogUsedTask !== null &&
      <Dialog open={true} onClose={() => setDataDialogUsedTask(null)}>
        <DialogContent style={{ minWidth: '200px', maxWidth: '600px' }}>
          {dataDialogUsedTask.length > 0 ? (
            <>
              Presente en <strong>{dataDialogUsedTask.length}</strong> {dataDialogUsedTask.length > 1 ? "tareas previas" : "tarea previa"} 
              <TableContainer component={Paper} style={{ marginTop: '10px', border: '3px solid #5ea0d4', borderRadius: '10px' }}>
                <Table>
                  <TableBody>
                    {dataDialogUsedTask.map((task, index) => (
                      <TableRow key={index}>
                        <TableCell
                          component="th"
                          scope="row"
                          style={{ textAlign: 'center', padding: '5px' }}
                        >
                          {task}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </>
          ) : (
            "No presente en ninguna tarea previa"
          )}
        </DialogContent>
      </Dialog>
    }
    </>
  );
}